import React from 'react';
import { FullScreenModal } from 'lib/components/FullScreenModal';
import { MdClose } from 'react-icons/md';
import {
  LinkBtn,
  LinkWrapper,
} from 'app/pages/library/videos/videoList/components/SendAndShare';
import { Title } from 'lib/components/toasts/index.styled';
import { VINReelsTable } from './VINReelsTable';

type Props = {
  handleModalClose: () => void;
  onCopy?: () => void;
};

export const ModalVinReels = ({ handleModalClose, onCopy }: Props) => {
  return (
    <FullScreenModal
      headerLeft={
        <LinkWrapper>
          <LinkBtn onClick={handleModalClose}>
            <MdClose size='18' />
            <span>Close</span>
          </LinkBtn>
        </LinkWrapper>
      }
      headerCenter={<Title>Available VINReels</Title>}
    >
      <VINReelsTable onCopy={onCopy} handleModalClose={handleModalClose} />
    </FullScreenModal>
  );
};
